// @flow

import { startup } from './chatbot'

startup()
